var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92195 11.9717C7.33195 11.9717 8.46195 13.1127 8.46195 14.5327V17.9417C8.46195 19.3517 7.33195 20.5017 5.92195 20.5017H2.54195C1.14195 20.5017 0.00195312 19.3517 0.00195312 17.9417V14.5327C0.00195312 13.1127 1.14195 11.9717 2.54195 11.9717H5.92195ZM17.4621 11.9717C18.8621 11.9717 20.0021 13.1127 20.0021 14.5327V17.9417C20.0021 19.3517 18.8621 20.5017 17.4621 20.5017H14.0821C12.6721 20.5017 11.5421 19.3517 11.5421 17.9417V14.5327C11.5421 13.1127 12.6721 11.9717 14.0821 11.9717H17.4621ZM5.92195 0.501953C7.33195 0.501953 8.46195 1.65195 8.46195 3.06295V6.47195C8.46195 7.89195 7.33195 9.03195 5.92195 9.03195H2.54195C1.14195 9.03195 0.00195312 7.89195 0.00195312 6.47195V3.06295C0.00195312 1.65195 1.14195 0.501953 2.54195 0.501953H5.92195ZM17.4621 0.501953C18.8621 0.501953 20.0021 1.65195 20.0021 3.06295V6.47195C20.0021 7.89195 18.8621 9.03195 17.4621 9.03195H14.0821C12.6721 9.03195 11.5421 7.89195 11.5421 6.47195V3.06295C11.5421 1.65195 12.6721 0.501953 14.0821 0.501953H17.4621Z",
    fill: "#0E60B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDashboard);
export default __webpack_public_path__ + "static/media/studentDashboard.9f61ba464e81b63d04b0afafd969a0bc.svg";
export { ForwardRef as ReactComponent };